import { useContext } from "react";
import { UserContext } from "../Context/UserContextAPI";

export default function useIsOneIntroducer() {
  const { introducerUsers, settingsData } = useContext(UserContext);
  return (
    introducerUsers?.length === 1 && settingsData?.agency_package_hide === 1
  );
}
